const getEvidenceLibraryOrigin = (value) => {
  try {
    const url = new URL(value);
    if (
      url.protocol === "https:" &&
      (url.hostname === "evidencelibrary.com" ||
        url.hostname.endsWith(".evidencelibrary.com"))
    ) {
      return url.origin;
    }
  } catch {}

  return null;
};

const gotoElUrl = (path) => {
  let baseUrl = getEvidenceLibraryOrigin(
    localStorage.getItem("EvidenceLibraryReferrer")
  );

  if (!baseUrl) {
    baseUrl = getEvidenceLibraryOrigin(document.referrer);
    if (baseUrl) {
      localStorage.setItem("EvidenceLibraryReferrer", baseUrl);
    } else {
      localStorage.removeItem("EvidenceLibraryReferrer");
    }
  }

  if (baseUrl) {
    var href = baseUrl.replace(/\/+$/, "");
    return path ? href + path : href;
  } else {
    return "/";
  }
};

export default gotoElUrl;
